/* YM free-shipping progress bar (2026-10-10; rev 2026-10-14: VIP Loyalty Free Shipping state, $100 copy). Self-contained; no shared logic modified. */
(function () {
  'use strict';
  if (window.YMFreeShipBar) return;

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var n = Number(cents);
    if (!isFinite(n)) n = 0;
    function delim(num, precision, thousands, decimal) {
      var parts = (num / 100).toFixed(precision).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (parts[1] ? decimal + parts[1] : '');
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = delim(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delim(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delim(n, 0, '.', ','); break;
      default: value = delim(n, 2, ',', '.');
    }
    return m ? fmt.replace(m[0], value) : value;
  }

  function render(el, cart) {
    if (!el || !cart || !el.dataset) return;
    var threshold = parseInt(el.dataset.threshold, 10);
    if (!threshold || threshold <= 0) return;
    var vip = el.dataset.vip === '1';
    var total = parseInt(cart.total_price, 10) || 0;
    var ex = String(el.dataset.excludeVendors || '').split('|').map(function (v) { return v.trim(); }).filter(Boolean);
    var hasEx = false;
    if (ex.length && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        if (ex.indexOf(String(cart.items[i].vendor || '').trim()) !== -1) {
          hasEx = true;
          total -= parseInt(cart.items[i].final_line_price, 10) || 0;
        }
      }
    }
    el.hidden = hasEx;
    if (hasEx) return;
    if (total < 0) total = 0;
    var remaining = vip ? 0 : Math.max(threshold - total, 0);
    var pct = vip ? 100 : Math.max(0, Math.min(100, Math.floor((total * 100) / threshold)));
    var met = remaining === 0;
    var msgEl = el.querySelector('[data-ym-fsb-msg]');
    var subEl = el.querySelector('[data-ym-fsb-sub]');
    var fillEl = el.querySelector('[data-ym-fsb-fill]');
    var trackEl = el.querySelector('[data-ym-fsb-track]');
    var amount = '<strong>' + escapeHtml(formatMoney(remaining, el.dataset.moneyFormat)) + '</strong>';
    if (msgEl) {
      if (vip) msgEl.innerHTML = escapeHtml(el.dataset.vipMsg || 'Loyalty Free Shipping');
      else if (met) msgEl.innerHTML = escapeHtml(el.dataset.success || "You've unlocked FREE shipping!");
      else msgEl.innerHTML = escapeHtml(el.dataset.msg || "You're [amount] away from free shipping").replace('[amount]', amount);
    }
    if (subEl) {
      var sub = vip ? el.dataset.vipSub : (met ? el.dataset.successSub : el.dataset.sub);
      subEl.textContent = sub || '';
      subEl.hidden = !sub;
    }
    if (fillEl) fillEl.style.width = pct + '%';
    if (trackEl) trackEl.setAttribute('aria-valuenow', String(pct));
    el.classList.toggle('ym-fsb--met', met);
    el.classList.toggle('ym-fsb--vip', vip);
  }

  function cartUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'cart.js';
  }

  var timer = null;
  var inflight = false;
  function refresh() {
    if (!window.fetch) return;
    if (!document.querySelector('[data-ym-fsb]')) return;
    if (inflight) { schedule(); return; }
    inflight = true;
    fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var els = document.querySelectorAll('[data-ym-fsb]');
        for (var i = 0; i < els.length; i++) render(els[i], cart);
      })
      .catch(function () {})
      .then(function () { inflight = false; });
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 250);
  }

  window.YMFreeShipBar = { refresh: refresh, render: render, formatMoney: formatMoney };

  ['cart:updated', 'cart:refresh', 'cart:change', 'cart-update', 'cart:build'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });

  // Passive: notice any cart mutation request (drawer qty buttons, add-to-cart, cart page) without patching fetch/XHR.
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        var entries = list.getEntries();
        for (var i = 0; i < entries.length; i++) {
          if (/\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(entries[i].name || '')) { schedule(); break; }
        }
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* unsupported */ }
  }

  window.addEventListener('pageshow', function (e) { if (e && e.persisted) schedule(); });
})();
